import { ref } from 'vue';
import {
  isHeadlineTime,
  useGetServerClock,
  useLiveOrdersQuery,
} from '@core/order';
import { CODES } from '@libs/use';

import { ORDER_SOCKET_ERROR_DESCRIPTION } from '@/modules/order';

export default function useHandleOrderSocketError() {
  const unsuccessfulOrderId = ref<string | number | null>(null);

  const { time, isErrorLoadingServerClock } = useGetServerClock();

  useLiveOrdersQuery({
    onUpdateCallback({ code, data }: { code: number; data: any }) {
      if (code === CODES.OmsOrderAndTradeSignal) {
        if (
          data.description &&
          !isErrorLoadingServerClock.value &&
          !isHeadlineTime(time.value) &&
          ORDER_SOCKET_ERROR_DESCRIPTION.includes(data.description)
        ) {
          unsuccessfulOrderId.value = data.orderId;

          return;
        }
      } else if (code === CODES.NewOmsOrderAndTradeSignal) {
        if (
          data.errorDescription &&
          !isErrorLoadingServerClock.value &&
          !isHeadlineTime(time.value) &&
          ORDER_SOCKET_ERROR_DESCRIPTION.includes(data.errorDescription)
        ) {
          unsuccessfulOrderId.value = data.orderId;

          return;
        }
      }

      unsuccessfulOrderId.value = null;
    },
  });

  return {
    unsuccessfulOrderId,
  };
}
